import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';
import config from './config';
import store from './store';
import { StylesProvider, createGenerateClassName } from '@material-ui/styles';
import { ApolloProvider } from 'react-apollo';
import AppSyncClient from './appsync';
import { Rehydrated } from 'aws-appsync-react';
import ChatMessagesListener from './components/HOC/ChatMessagesListener';

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  },
  ...config.appsync
});

// use a different production css name prefix since the default 'jss' was causing clashes with 'material-table'
const generateClassName = createGenerateClassName({
  productionPrefix: 'kt'
});

ReactDOM.render(
  <Provider store={store}>
    <StylesProvider generateClassName={generateClassName}>
      <ApolloProvider client={AppSyncClient}>
        <Rehydrated>
          <ChatMessagesListener>
            <App />
          </ChatMessagesListener>
        </Rehydrated>
      </ApolloProvider>
    </StylesProvider>
  </Provider>,
  document.getElementById('root')
);
unregister();
